function checkForRepeatContactEntry(contactEmail, contactArray) {
    for (var i = 0; i < contactArray.length; i++) {
        if (contactArray[i].email === contactEmail) {
            return true;
        }
    }
    return false;
}

export default function SortApplicationsByState(applications) {
    const states = {
        "Alabama": [],
        "Alaska": [],
        "Arizona": [],
        "Arkansas": [],
        "California": [],
        "Colorado": [],
        "Connecticut": [],
        "Delaware": [],
        "Florida": [],
        "Georgia": [],
        "Hawaii": [],
        "Idaho": [],
        "Illinois": [],
        "Indiana": [],
        "Iowa": [],
        "Kansas": [],
        "Kentucky": [],
        "Louisiana": [],
        "Maine": [],
        "Maryland": [],
        "Massachusetts": [],
        "Michigan": [],
        "Minnesota": [],
        "Mississippi": [],
        "Missouri": [],
        "Montana": [],
        "Nebraska": [],
        "Nevada": [],
        "NewHampshire": [],
        "NewJersey": [],
        "NewMexico": [],
        "NewYork": [],
        "NorthCarolina": [],
        "NorthDakota": [],
        "Ohio": [],
        "Oklahoma": [],
        "Oregon": [],
        "Pennsylvania": [],
        "RhodeIsland": [],
        "SouthCarolina": [],
        "SouthDakota": [],
        "Tennessee": [],
        "Texas": [],
        "Utah": [],
        "Vermont": [],
        "Virginia": [],
        "Washington": [],
        "WestVirginia": [],
        "Wisconsin": [],
        "Wyoming": []
    };

    applications.forEach(app => {
        const contactInfo = {
            name: app.firstName + " " + app.lastName,
            email: app.email,
            phone: app.phone,
            state: app.state,
            city: app.city,
            ZIP: app.ZIP,
        };

        switch (app.state) {
            case "Alabama":
                if (!checkForRepeatContactEntry(app.email, states.Alabama)) {
                    states.Alabama.push(contactInfo);
                }
                break;
            case "Alaska":
                if (!checkForRepeatContactEntry(app.email, states.Alaska)) {
                    states.Alaska.push(contactInfo);
                }
                break;
            case "Arizona":
                if (!checkForRepeatContactEntry(app.email, states.Arizona)) {
                    states.Arizona.push(contactInfo);
                }
                break;
            case "Arkansas":
                if (!checkForRepeatContactEntry(app.email, states.Arkansas)) {
                    states.Arkansas.push(contactInfo);
                }
                break;
            case "California":
                if (!checkForRepeatContactEntry(app.email, states.California)) {
                    states.California.push(contactInfo);
                }
                break;
            case "Colorado":
                if (!checkForRepeatContactEntry(app.email, states.Colorado)) {
                    states.Colorado.push(contactInfo);
                }
                break;
            case "Connecticut":
                if (!checkForRepeatContactEntry(app.email, states.Connecticut)) {
                    states.Connecticut.push(contactInfo);
                }
                break;
            case "Delaware":
                if (!checkForRepeatContactEntry(app.email, states.Delaware)) {
                    states.Delaware.push(contactInfo);
                }
                break;
            case "Florida":
                if (!checkForRepeatContactEntry(app.email, states.Florida)) {
                    states.Florida.push(contactInfo);
                }
                break;
            case "Georgia":
                if (!checkForRepeatContactEntry(app.email, states.Georgia)) {
                    states.Georgia.push(contactInfo);
                }
                break;
            case "Hawaii":
                if (!checkForRepeatContactEntry(app.email, states.Hawaii)) {
                    states.Hawaii.push(contactInfo);
                }
                break;
            case "Idaho":
                if (!checkForRepeatContactEntry(app.email, states.Idaho)) {
                    states.Idaho.push(contactInfo);
                }
                break;
            case "Illinois":
                if (!checkForRepeatContactEntry(app.email, states.Illinois)) {
                    states.Illinois.push(contactInfo);
                }
                break;
            case "Indiana":
                if (!checkForRepeatContactEntry(app.email, states.Indiana)) {
                    states.Indiana.push(contactInfo);
                }
                break;
            case "Iowa":
                if (!checkForRepeatContactEntry(app.email, states.Iowa)) {
                    states.Iowa.push(contactInfo);
                }
                break;
            case "Kansas":
                if (!checkForRepeatContactEntry(app.email, states.Kansas)) {
                    states.Kansas.push(contactInfo);
                }
                break;
            case "Kentucky":
                if (!checkForRepeatContactEntry(app.email, states.Kentucky)) {
                    states.Kentucky.push(contactInfo);
                }
                break;
            case "Louisiana":
                if (!checkForRepeatContactEntry(app.email, states.Louisiana)) {
                    states.Louisiana.push(contactInfo);
                }
                break;
            case "Maine":
                if (!checkForRepeatContactEntry(app.email, states.Maine)) {
                    states.Maine.push(contactInfo);
                }
                break;
            case "Maryland":
                if (!checkForRepeatContactEntry(app.email, states.Maryland)) {
                    states.Maryland.push(contactInfo);
                }
                break;
            case "Massachusetts":
                if (!checkForRepeatContactEntry(app.email, states.Massachusetts)) {
                    states.Massachusetts.push(contactInfo);
                }
                break;
            case "Michigan":
                if (!checkForRepeatContactEntry(app.email, states.Michigan)) {
                    states.Michigan.push(contactInfo);
                }
                break;
            case "Minnesota":
                if (!checkForRepeatContactEntry(app.email, states.Minnesota)) {
                    states.Minnesota.push(contactInfo);
                }
                break;
            case "Mississippi":
                if (!checkForRepeatContactEntry(app.email, states.Mississippi)) {
                    states.Mississippi.push(contactInfo);
                }
                break;
            case "Missouri":
                if (!checkForRepeatContactEntry(app.email, states.Missouri)) {
                    states.Missouri.push(contactInfo);
                }
                break;
            case "Montana":
                if (!checkForRepeatContactEntry(app.email, states.Montana)) {
                    states.Montana.push(contactInfo);
                }
                break;
            case "Nebraska":
                if (!checkForRepeatContactEntry(app.email, states.Nebraska)) {
                    states.Nebraska.push(contactInfo);
                }
                break;
            case "Nevada":
                if (!checkForRepeatContactEntry(app.email, states.Nevada)) {
                    states.Nevada.push(contactInfo);
                }
                break;
            case "New Hampshire":
                if (!checkForRepeatContactEntry(app.email, states.NewHampshire)) {
                    states.NewHampshire.push(contactInfo);
                }
                break;
            case "New Jersey":
                if (!checkForRepeatContactEntry(app.email, states.NewJersey)) {
                    states.NewJersey.push(contactInfo);
                }
                break;
            case "New Mexico":
                if (!checkForRepeatContactEntry(app.email, states.NewMexico)) {
                    states.NewMexico.push(contactInfo);
                }
                break;
            case "New York":
                if (!checkForRepeatContactEntry(app.email, states.NewYork)) {
                    states.NewYork.push(contactInfo);
                }
                break;
            case "North Carolina":
                if (!checkForRepeatContactEntry(app.email, states.NorthCarolina)) {
                    states.NorthCarolina.push(contactInfo);
                }
                break;
            case "North Dakota":
                if (!checkForRepeatContactEntry(app.email, states.NorthDakota)) {
                    states.NorthDakota.push(contactInfo);
                }
                break;
            case "Ohio":
                if (!checkForRepeatContactEntry(app.email, states.Ohio)) {
                    states.Ohio.push(contactInfo);
                }
                break;
            case "Oklahoma":
                if (!checkForRepeatContactEntry(app.email, states.Oklahoma)) {
                    states.Oklahoma.push(contactInfo);
                }
                break;
            case "Oregon":
                if (!checkForRepeatContactEntry(app.email, states.Oregon)) {
                    states.Oregon.push(contactInfo);
                }
                break;
            case "Pennsylvania":
                if (!checkForRepeatContactEntry(app.email, states.Pennsylvania)) {
                    states.Pennsylvania.push(contactInfo);
                }
                break;
            case "Rhode Island":
                if (!checkForRepeatContactEntry(app.email, states.RhodeIsland)) {
                    states.RhodeIsland.push(contactInfo);
                }
                break;
            case "South Carolina":
                if (!checkForRepeatContactEntry(app.email, states.SouthCarolina)) {
                    states.SouthCarolina.push(contactInfo);
                }
                break;
            case "South Dakota":
                if (!checkForRepeatContactEntry(app.email, states.SouthDakota)) {
                    states.SouthDakota.push(contactInfo);
                }
                break;
            case "Tennessee":
                if (!checkForRepeatContactEntry(app.email, states.Tennessee)) {
                    states.Tennessee.push(contactInfo);
                }
                break;
            case "Texas":
                if (!checkForRepeatContactEntry(app.email, states.Texas)) {
                    states.Texas.push(contactInfo);
                }
                break;
            case "Utah":
                if (!checkForRepeatContactEntry(app.email, states.Utah)) {
                    states.Utah.push(contactInfo);
                }
                break;
            case "Vermont":
                if (!checkForRepeatContactEntry(app.email, states.Vermont)) {
                    states.Vermont.push(contactInfo);
                }
                break;
            case "Virginia":
                if (!checkForRepeatContactEntry(app.email, states.Virginia)) {
                    states.Virginia.push(contactInfo);
                }
                break;
            case "Washington":
                if (!checkForRepeatContactEntry(app.email, states.Washington)) {
                    states.Washington.push(contactInfo);
                }
                break;
            case "West Virginia":
                if (!checkForRepeatContactEntry(app.email, states.WestVirginia)) {
                    states.WestVirginia.push(contactInfo);
                }
                break;
            case "Wisconsin":
                if (!checkForRepeatContactEntry(app.email, states.Wisconsin)) {
                    states.Wisconsin.push(contactInfo);
                }
                break;
            case "Wyoming":
                if (!checkForRepeatContactEntry(app.email, states.Wyoming)) {
                    states.Wyoming.push(contactInfo);
                }
                break;

            default: {
                break;
            }
        }
    });
    return states;
}